<template>
  <div class="p-8 h-full">
    <div class="flex gap-6 p-4 rounded-xl bg-white h-full" style="box-shadow:0 5px 15px 0 rgba(0,0,0,0.08);">
      <section class="flex flex-col gap-6 p-3 pb-16 rounded-lg bg-slate-100 w-fit items-center">
        <div class="mb-12 bg-white p-5 rounded-full" />
        <div class="circle bg-slate-200 p-4 rounded-full" v-for="i in 6" :key="i" />
      </section>

      <section class="w-full overflow-hidden ">
        <div class="w-full flex items-center justify-between">
          <h4 class="text-grey-500 text-2xl">
            {{ boardName ? boardName : "Hiring Board" }}
          </h4>
          <span class="flex items-center gap-4">
            <div class="bg-grey-200 py-2 px-8 rounded-full" />
            <div class="bg-blue-100 p-4 w-10 h-10 rounded-full" />
          </span>
        </div>
        <div class="w-full flex items-center justify-between mt-5">
          <div class="w-7/12 py-2 px-10 bg-slate-100 rounded-full"></div>
          <div class="w-24 bg-primary py-5 px-12 rounded-lg opacity-75 flex justify-center items-center relative">
            <div class="w-7/12 absolute py-2 bg-white rounded-full opacity-50"></div>
          </div>
        </div>

        <div class="w-full h-full relative flex gap-4">
          <vue-perfect-scrollbar class="flex gap-6 mt-6 bg-slate-00 w-full h-fit relative"
            v-if="this.kanbanData && this.kanbanData.cols">
            <div class="h-full flex flex-col" v-for="col in this.kanbanData.cols" :key="col._id">
              <div>
                <div class="bg-slate-100 py-2 px-3 rounded-lg wc-20 flex justify-between items-center">
                  <h4 class="text-grey-700 text-lg">{{ col.title }}</h4>
                  <div class="bg-slate-200 p-4 w-4 h-4 rounded-full" />
                </div>
              </div>
              <div class="bg-slate-100 p-2 my-6 rounded-lg flex flex-col gap-4">
                <div class="flex flex-col gap-4 bg-white p-2 rounded-lg" v-for="i in rangedRandomNumber()" :key="i">
                  <div class="flex items-center gap-4">
                    <div class="p-3 w-10 h-10 rounded-full" :class="getRandomColor()" />
                    <span class="flex flex-col items-start">
                      <div class="bg-slate-200 py-1 px-6 w-24 rounded-full" />
                      <div class="bg-slate-200 py-1 mt-2 px-16 rounded-full" />
                    </span>
                  </div>
                  <div v-if="rangedRandomNumber() === i" class="flex flex-col">
                    <div class="bg-slate-200 w-11/12 py-2 mt-0 px-16 rounded-full" />
                    <div class="bg-slate-200 w-full py-1 mt-2 px-16 rounded-full" />
                  </div>
                </div>
              </div>
            </div>
          </vue-perfect-scrollbar>

          <vue-perfect-scrollbar class="flex gap-6 mt-6 bg-slate-00 w-full h-fit relative" v-else>
            <div class="h-full flex flex-col" v-for="col in this.dummyData" :key="col._id">
              <div>
                <div class="bg-slate-100 py-2 px-3 rounded-lg wc-20 flex justify-between items-center">
                  <h4 class="text-grey-700 text-lg">{{ col.title }}</h4>
                  <div class="bg-slate-200 p-4 w-4 h-4 rounded-full" />
                </div>
              </div>
              <div class="bg-slate-100 p-2 my-6 rounded-lg flex flex-col gap-4">
                <div class="flex flex-col gap-4 bg-white p-2 rounded-lg" v-for="i in rangedRandomNumber()" :key="i">
                  <div class="flex items-center gap-4">
                    <div class="p-3 w-10 h-10 rounded-full" :class="getRandomColor()" />
                    <span class="flex flex-col items-start">
                      <div class="bg-slate-200 py-1 px-6 w-24 rounded-full" />
                      <div class="bg-slate-200 py-1 mt-2 px-16 rounded-full" />
                    </span>
                  </div>
                  <div v-if="rangedRandomNumber() === i" class="flex flex-col">
                    <div class="bg-slate-200 w-11/12 py-2 mt-0 px-16 rounded-full" />
                    <div class="bg-slate-200 w-full py-1 mt-2 px-16 rounded-full" />
                  </div>
                </div>
              </div>
            </div>
          </vue-perfect-scrollbar>
          <div class="px-6 py-32 mt-6 h-fit bg-slate-200 relative flex justify-center items-center rounded-lg">
            <p
              class="absolute flex flex-row items-center justify-center gap-4 rotate-90 transform text-xl whitespace-no-wrap text-slate-400">
              <span class="w-5 h-5 flex justify-start items-start">
                <svg class="w-full h-full object-cover" width="21" height="21" viewBox="0 0 21 21" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.5 10.5L10.5 10.5L7.5 10.5ZM10.5 10.5L13.5 10.5L10.5 10.5ZM10.5 10.5L10.5 7.5L10.5 10.5ZM10.5 10.5L10.5 13.5L10.5 10.5ZM10.5 1.5C11.6819 1.5 12.8522 1.73279 13.9442 2.18508C15.0361 2.63738 16.0282 3.30031 16.864 4.13604C17.6997 4.97177 18.3626 5.96392 18.8149 7.05585C19.2672 8.14778 19.5 9.3181 19.5 10.5C19.5 11.6819 19.2672 12.8522 18.8149 13.9442C18.3626 15.0361 17.6997 16.0282 16.864 16.864C16.0282 17.6997 15.0361 18.3626 13.9442 18.8149C12.8522 19.2672 11.6819 19.5 10.5 19.5C8.11305 19.5 5.82387 18.5518 4.13604 16.864C2.44821 15.1761 1.5 12.8869 1.5 10.5C1.5 8.11305 2.44821 5.82387 4.13604 4.13604C5.82387 2.44821 8.11305 1.5 10.5 1.5Z"
                    stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

              </span>
              Add Column
            </p>

          </div>

        </div>
      </section>
    </div>
  </div>
</template>

<script>
import commonMixin from "../mixins/commonMixin";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  mixins: [commonMixin],
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      colors: [
        "pink",
        "indigo",
        "blue",
        "purple",
        "red",
        "light-blue",
        "cyan",
        "teal",
        "green",
        "lime",
        "light-green",
        "yellow",
        "amber",
        "orange",
        "deep-orange",
        "brown",
        "blue-grey",
      ],
      dummyData: [{ title: "On Board" }, { title: "Doing" }, { title: "Done" }],
    };
  },
  props: {
    boardTitle: {
      type: String,
    },
  },
  watch: {
    boardTitle: {
      handler(newVal) {
        this.boardName = newVal;
      },
    },
  },
  methods: {
    getRandomColor() {
      const randomColor =
        this.colors[Math.floor(Math.random() * this.colors.length)];
      const randomValue = Math.random() < 0.5 ? "100" : "200";
      return `bg-${randomColor}-${randomValue}`;
    },
    rangedRandomNumber() {
      return Math.floor(Math.random() * 3) + 1; // Random number between 1 and 3
    },
  },
};
</script>

<style scoped>
.bggg {
  background: url("../../../../../../assets/images/create-board-bg.png");
}

.wc-20 {
  width: 15rem;
}
</style>
